import { IHcp } from '../../interfaces/ucr';

export function getHcp(hcpUsers: IHcp[], userId: undefined | null | string) {
    if (!userId || userId === null) {
        return undefined;
    }

    return hcpUsers.find((hcp) => hcp.userId === userId);
}
